export enum ExclusiveRouteType {
  /**
   * A System Administrator route for System Administrators caregivers
   */
  SystemAdministrator = 'system-administrator',

  /**
   * A Partner route for Partner caregivers
   */
  Partner = 'partner',

  /**
   * An Affiliation route for Professional caregivers
   */
  ProfessionalCaregiver = 'professional-caregiver',

  /**
   * A Relationship route for Informal caregivers
   */
  InformalCaregiver = 'informal-caregiver',

  /**
   * A Me route for any caregiver
   */
  Me = 'me',
}
